<template>
    <div id="dark-switch" class="white ml-4">
        <toggle-button :value="dark_mode"
            :labels="{checked: '\uf186', unchecked: '\uf185'}"
            @change="toggleDarkMode"
            :color="{checked: '#e9ecef', unchecked: '#495057'}"
            :switch-color="{checked: '#495057', unchecked: '#e9ecef'}"
            />
    </div>    
</template>
<script>
    export default {
        data () {
            return {
                dark_mode : false,
                skip_toggle_dark_mode : false
            }
        },
        methods: {
            toggleDarkMode(event){
                if(this.skip_toggle_dark_mode){
                    this.skip_toggle_dark_mode = false;
                    return;
                }
                let state = event.value;
                axios.post("/api/profile/setDarkMode", {dark_mode:state}).then(({ data }) => {
                   if(data.data){
                       $('body').addClass('dark-mode');
                   }else{
                       $('body').removeClass('dark-mode');
                   }
                   this.$root.app_config.dark_mode = data.data;
                   this.$root.$emit('renderSocialSearchersCharts');
                   this.$root.$emit('buildTagCloud');
                });
            },
            loadProfile(){
                axios.get("/api/profile").then(({ data }) => {
                    if(data.data.dark_mode==1){
                        this.skip_toggle_dark_mode = true;
                        $('#dark-switch .v-switch-input').trigger('click');
                    }
                    this.dark_mode = data.data.dark_mode==1 ? true : false;
                });
            },
        },
        mounted() {
            this.loadProfile();
        }
    }
</script>
